<script>
  import { _ } from 'svelte-intl';
  import { stores } from '@sapper/app';
  import { config, popup } from '../../stores';
  import Button from '../Button.svelte';
  import BookAvailableUntil from '../BookAvailableUntil.svelte';
  import ExternalLinkIcon from '../ExternalLinkIcon.svelte';
  import Pricetag from '../Pricetag.svelte';
  import * as analytics from '../../helpers/analytics';
  import generateDynamicLink from '../../helpers/generateDynamicLink';
  import * as urlFor from '../../helpers/urlFor';

  const { page, session } = stores();

  export let book; // Book
  // Purchase is a prop because it should be optimistically updated from the outside
  export let purchase; // Purchase
  export let openPurchaseConfirm; // () => void

  $: dynamicLink = generateDynamicLink(
    $config,
    `https://${$page.host}${urlFor.book(book)}`
  );

  async function showGetTheAppPopup(event) {
    if ($session.mobilePlatform) return;

    event.preventDefault();
    analytics.readInApp(book);

    const { default: GetTheApp } = await import('../GetTheApp.svelte');
    popup.show(GetTheApp, {}, { autoSize: true });
  }
</script>

<style lang="stylus">
  span
    vertical-align bottom

  .read-in-app-label
    line-height 22px
</style>

{#if purchase}
<div>
  <Button primary large on:click={showGetTheAppPopup} href={dynamicLink} rel="nofollow" target="_blank">
    <span class="read-in-app-label">
      {$_('read_in_app')}
    </span>
    <ExternalLinkIcon />
  </Button>
  <BookAvailableUntil {purchase} />
</div>
{/if}

{#if book.price.rent && !purchase}
<div>
  <Button primary large on:click={openPurchaseConfirm}>
    <span>
      {$_('rent_for_label')}
    </span>
    <Pricetag amount={book.price.rent} large inline alignBottom />
  </Button>
</div>
{/if}

{#if book.price.purchase && !purchase}
<div>
  <Button secondary large on:click={openPurchaseConfirm}>
    <span>
      {$_('buy_for_label')}
    </span>
    <Pricetag amount={book.price.purchase} large inline alignBottom />
  </Button>
</div>
{/if}

{#if book.price.redeem && purchase && purchase.type === 'RENT'}
<div>
  <Button secondary large on:click={openPurchaseConfirm}>
    <span>
      {$_('redeem_for_label')}
    </span>
    <Pricetag amount={book.price.redeem} large inline alignBottom />
  </Button>
</div>
{/if}
